import React from 'react';
import AddRefundCreditModal from "./AddRefundCreditModal";
import CreateRequestRefundModal from "./CreateRequestRefundModal";
import ManageRequestRefundModal from "./ManageRequestRefundModal";
import RequestPayoutOnHoldModal from './RequestPayoutOnHoldModal';
import CancelInvoiceModal from "./CancelInvoiceModal";
import MarkInvoiceAsPaidModal from './MarkInvoiceAsPaidModal';
import {InvoiceActionDialogs} from "../InvoiceActions";

const InvoiceActionsDialogWrapper = ({
  activeDialog,
  account,
  invoice,
  onInvoiceAction,
  onClose
}) => {

  const onDialogClose = (...e) => {
    onClose && onClose(...e);
  }

  return (
    <>
      <AddRefundCreditModal open={activeDialog === InvoiceActionDialogs.ADD_REFUND_CREDIT} account={account} invoice={invoice} onInvoiceAction={onInvoiceAction} onClose={onDialogClose} />
      <CreateRequestRefundModal open={activeDialog === InvoiceActionDialogs.CREATE_REQUEST_REFUND} account={account} invoice={invoice} onInvoiceAction={onInvoiceAction} onClose={onDialogClose} />
      <ManageRequestRefundModal open={activeDialog === InvoiceActionDialogs.MANAGE_REQUEST_REFUND} account={account} invoice={invoice} onInvoiceAction={onInvoiceAction} onClose={onDialogClose} />
      <CancelInvoiceModal open={activeDialog === InvoiceActionDialogs.CANCEL_INVOICE} account={account} invoice={invoice} onInvoiceAction={onInvoiceAction} onClose={onDialogClose} />
      <RequestPayoutOnHoldModal open={activeDialog === InvoiceActionDialogs.REQUEST_PUT_PAYOUT_ON_HOLD} invoice={invoice} onInvoiceAction={onInvoiceAction} onClose={onDialogClose} />
      <MarkInvoiceAsPaidModal open={activeDialog === InvoiceActionDialogs.MARK_INVOICE_AS_PAID} invoice={invoice} onInvoiceAction={onInvoiceAction} onClose={onDialogClose} />
    </>
  );
};

export default InvoiceActionsDialogWrapper;
